import { render, staticRenderFns } from "./ErroVersao.vue?vue&type=template&id=305242f0&scoped=true&"
import script from "./ErroVersao.vue?vue&type=script&lang=js&"
export * from "./ErroVersao.vue?vue&type=script&lang=js&"
import style0 from "./ErroVersao.vue?vue&type=style&index=0&id=305242f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305242f0",
  null
  
)

export default component.exports